import { ActionIconProps } from "@mantine/core";
import { IconProps } from "@phosphor-icons/react";

export const ICON_PROPS: IconProps = {
  weight: "fill",
  size: 24
};

export const ACTION_ICON_PROPS: ActionIconProps = {
  variant: "outline",
  size: "lg",
  radius: "sm"
};
